import { render } from "./IconUpDown.vue?vue&type=template&id=3f623e1e"
import script from "./IconUpDown.vue?vue&type=script&lang=js"
export * from "./IconUpDown.vue?vue&type=script&lang=js"
script.render = render

export default script